module.exports = __webpack_public_path__ + "static/media/arrow-circle-full-green.d7358ad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-full-green.svg
// module id = 105
// module chunks = 0